import React, { useEffect, useState } from 'react';
import AdminLayout from '@/components/admin/AdminLayout';
import { API, toast } from '@/App';
import axios from 'axios';
import { Plus, Edit, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';

const AdminTeam = () => {
  const [team, setTeam] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editingMember, setEditingMember] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    position: '',
    bio: '',
    image_url: '',
    social_links: {},
    order: 0,
    active: true,
  });

  useEffect(() => {
    fetchTeam();
  }, []);

  const fetchTeam = async () => {
    try {
      const response = await axios.get(`${API}/team`);
      setTeam(response.data);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingMember) {
        await axios.put(`${API}/team/${editingMember.id}`, formData);
        toast.success('Üye güncellendi!');
      } else {
        await axios.post(`${API}/team`, formData);
        toast.success('Üye eklendi!');
      }
      setDialogOpen(false);
      resetForm();
      fetchTeam();
    } catch (error) {
      toast.error('Bir hata oluştu!');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Bu üyeyi silmek istediğinizden emin misiniz?')) return;
    try {
      await axios.delete(`${API}/team/${id}`);
      toast.success('Üye silindi!');
      fetchTeam();
    } catch (error) {
      toast.error('Silme başarısız!');
    }
  };

  const handleEdit = (member) => {
    setEditingMember(member);
    setFormData({
      name: member.name,
      position: member.position,
      bio: member.bio,
      image_url: member.image_url || '',
      social_links: member.social_links || {},
      order: member.order,
      active: member.active,
    });
    setDialogOpen(true);
  };

  const resetForm = () => {
    setEditingMember(null);
    setFormData({
      name: '',
      position: '',
      bio: '',
      image_url: '',
      social_links: {},
      order: 0,
      active: true,
    });
  };

  return (
    <AdminLayout>
      <div data-testid="admin-team-page">
        <div className="flex justify-between items-center mb-8">
          <div>
            <h1 className="text-3xl font-bold mb-2">Ekip</h1>
            <p className="text-white/60">Ekip üyelerinizi yönetin</p>
          </div>
          <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
            <DialogTrigger asChild>
              <Button onClick={() => resetForm()} data-testid="add-member-button" className="bg-gradient-to-r from-[#FF6B35] to-[#F7931E]">
                <Plus className="w-4 h-4 mr-2" />
                Yeni Üye
              </Button>
            </DialogTrigger>
            <DialogContent className="bg-[#1a1a1f] border-white/10 text-white max-w-2xl max-h-[90vh] overflow-y-auto">
              <DialogHeader>
                <DialogTitle>{editingMember ? 'Üye Düzenle' : 'Yeni Üye Ekle'}</DialogTitle>
              </DialogHeader>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium mb-2">Ad Soyad</label>
                  <Input value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} required className="bg-white/5 border-white/10 text-white" />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-2">Pozisyon</label>
                  <Input value={formData.position} onChange={(e) => setFormData({ ...formData, position: e.target.value })} required className="bg-white/5 border-white/10 text-white" />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-2">Biyografi</label>
                  <Textarea value={formData.bio} onChange={(e) => setFormData({ ...formData, bio: e.target.value })} required rows={3} className="bg-white/5 border-white/10 text-white" />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-2">Görsel URL</label>
                  <Input value={formData.image_url} onChange={(e) => setFormData({ ...formData, image_url: e.target.value })} placeholder="https://..." className="bg-white/5 border-white/10 text-white" />
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium mb-2">LinkedIn</label>
                    <Input value={formData.social_links.linkedin || ''} onChange={(e) => setFormData({ ...formData, social_links: { ...formData.social_links, linkedin: e.target.value }})} placeholder="https://linkedin.com/in/..." className="bg-white/5 border-white/10 text-white" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-2">Twitter</label>
                    <Input value={formData.social_links.twitter || ''} onChange={(e) => setFormData({ ...formData, social_links: { ...formData.social_links, twitter: e.target.value }})} placeholder="https://twitter.com/..." className="bg-white/5 border-white/10 text-white" />
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium mb-2">Sıra</label>
                    <Input type="number" value={formData.order} onChange={(e) => setFormData({ ...formData, order: parseInt(e.target.value) })} className="bg-white/5 border-white/10 text-white" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-2">Aktif</label>
                    <select value={formData.active.toString()} onChange={(e) => setFormData({ ...formData, active: e.target.value === 'true' })} className="w-full px-3 py-2 bg-white/5 border border-white/10 rounded-md text-white">
                      <option value="true">Evet</option>
                      <option value="false">Hayır</option>
                    </select>
                  </div>
                </div>
                <Button type="submit" className="w-full bg-gradient-to-r from-[#FF6B35] to-[#F7931E]">
                  {editingMember ? 'Güncelle' : 'Ekle'}
                </Button>
              </form>
            </DialogContent>
          </Dialog>
        </div>

        {loading ? (
          <div className="text-white/60">Yükleniyor...</div>
        ) : team.length === 0 ? (
          <div className="glass p-8 rounded-2xl text-center text-white/60">
            Henüz üye eklenmemiş. Hemen bir tane ekleyin!
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {team.map((member) => (
              <div key={member.id} className="glass rounded-2xl overflow-hidden" data-testid={`member-item-${member.id}`}>
                <div className="h-48 bg-gradient-to-br from-[#FF6B35]/20 to-[#F7931E]/20 flex items-center justify-center">
                  {member.image_url ? (
                    <img src={member.image_url} alt={member.name} className="w-full h-full object-cover" />
                  ) : (
                    <div className="text-5xl">👤</div>
                  )}
                </div>
                <div className="p-4">
                  <div className="flex justify-between items-start mb-2">
                    <div className="flex-1">
                      <h3 className="font-semibold">{member.name}</h3>
                      <p className="text-xs text-[#FF6B35]">{member.position}</p>
                    </div>
                    <div className="flex space-x-1">
                      <button onClick={() => handleEdit(member)} className="p-1 rounded hover:bg-white/10" data-testid={`edit-member-${member.id}`}>
                        <Edit className="w-4 h-4" />
                      </button>
                      <button onClick={() => handleDelete(member.id)} className="p-1 rounded hover:bg-red-500/20 text-red-500" data-testid={`delete-member-${member.id}`}>
                        <Trash2 className="w-4 h-4" />
                      </button>
                    </div>
                  </div>
                  <p className="text-xs text-white/60 line-clamp-2">{member.bio}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </AdminLayout>
  );
};

export default AdminTeam;